module.exports = __webpack_public_path__ + "img/Оңтүстік Қазақстан облысы.9ba90441.png";